const initialState = {
  list: [],
  loading: false,
  updating: false,
  selectedDeleteCampaign: {},
  deleting: false,
  deleteError: false,
  deleteSuccess: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'CLOSE_MODAL':
      return { ...state, deleteError: false, deleteSuccess: false };
    case 'CAMPAIGN_DELETE_SUCCESS':
      return { ...state, deleteSuccess: true };
    case 'CAMPAIGN_DELETE_ERROR':
      return { ...state, deleteError: action.status };
    case 'CAMPAIGN_DELETING':
      return { ...state, deleting: action.status };
    case 'SELECT_DELETE_CAMPAIGN':
      return { ...state, selectedDeleteCampaign: action.payload };
    case 'SET_CAMPAIGNS_LOADING':
      return { ...state, loading: action.payload };
    case 'SET_CAMPAIGNS_UPDATING':
      return { ...state, updating: action.payload };
    case 'UPDATE_CAMPAIGN': {
      const campaignToUpdate = state.list.find((c) => c.id === action.payload.id);
      const indexToUpdate = state.list.indexOf(campaignToUpdate);
      const newList = state.list
        .map((c, index) => {
          if (index === indexToUpdate) {
            return action.payload.data;
          }
          return c;
        });
      return {
        ...state,
        list: newList,
      };
    }
    case 'LOAD_CAMPAIGNS':
      return { ...state, list: action.payload };
    case 'CLEAR':
      return { ...initialState };
    default:
      return state;
  }
};
